module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("2NAey"))).then(() => parcelRequire('1iHdE'));